// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"ea7db2b4","58":"34ee5fb1","156":"3d6f079e","372":"ce279a50","461":"65245e20","480":"a12111e5","508":"edf8b42f","602":"5c577886","818":"430f9122"}[chunkId] + ".chunk.js";
};